/* VM PEÇAS — scripts das seções customizadas */
(function () {
  'use strict';

  /* ================= Núcleo da lista de orçamento (puro, testável) ================= */
  function createQuoteStore(storage, key) {
    key = key || 'vm_orcamento_v1';
    let mem = { items: [] };
    const load = () => {
      try {
        const raw = storage && storage.getItem(key);
        if (raw) { const d = JSON.parse(raw); if (d && Array.isArray(d.items)) return d; }
      } catch (e) {}
      return JSON.parse(JSON.stringify(mem));
    };
    const save = (d) => { mem = d; try { storage && storage.setItem(key, JSON.stringify(d)); } catch (e) {} };
    return {
      items: () => load().items,
      count: () => load().items.reduce((a, i) => a + i.qty, 0),
      add(item, qty) {
        qty = Math.max(1, parseInt(qty, 10) || 1);
        const d = load(); const id = String(item.id); const f = d.items.find((i) => i.id === id);
        if (f) f.qty = Math.min(999, f.qty + qty);
        else d.items.push({ id, sku: item.sku || '', title: item.title || '', variant: item.variant || '', url: item.url || '', image: item.image || '', qty: Math.min(999, qty) });
        save(d);
      },
      setQty(id, qty) {
        const d = load(); id = String(id); qty = parseInt(qty, 10);
        if (!(qty > 0)) d.items = d.items.filter((i) => i.id !== id);
        else { const f = d.items.find((i) => i.id === id); if (f) f.qty = Math.min(999, qty); }
        save(d);
      },
      remove(id) { const d = load(); d.items = d.items.filter((i) => i.id !== String(id)); save(d); },
      clear() { save({ items: [] }); },
    };
  }
  const quoteLabel = (it) => it.title + (it.variant ? ' [' + it.variant + ']' : '') + (it.sku && String(it.title).indexOf(it.sku) === -1 ? ' (cód. ' + it.sku + ')' : '');
  function buildQuoteMessage(items, form) {
    const f = form || {};
    const out = ['Olá! Gostaria de um orçamento:'];
    items.forEach((it, i) => out.push((i + 1) + ') ' + it.qty + 'x ' + quoteLabel(it)));
    const extra = [['Nome', f.nome], ['Cidade', f.cidade], ['Veículo', f.veiculo], ['Obs.', f.obs]]
      .filter((p) => p[1] && String(p[1]).trim())
      .map((p) => p[0] + ': ' + String(p[1]).trim());
    if (extra.length) out.push('', ...extra);
    return out.join('\n');
  }
  const buildDirectMessage = (it) => 'Olá! Gostaria de um orçamento da peça: ' + quoteLabel(it);
  const waLink = (number, text) => 'https://wa.me/' + String(number || '').replace(/\D/g, '') + '?text=' + encodeURIComponent(text);

  const buildVehicleQuery = ({ marca, modelo, peca } = {}) => {
    const t = [];
    if (peca && String(peca).trim()) t.push(String(peca).trim());
    if (modelo) t.push(modelo); else if (marca) t.push(marca);
    return t.join(' ');
  };

  const core = { createQuoteStore, buildQuoteMessage, buildDirectMessage, waLink, buildVehicleQuery };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (typeof window === 'undefined') return;
  window.VMQuoteCore = core;

  /* ================= UI ================= */
  if (window.__vmInit) return;
  window.__vmInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents) =>
    (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const esc = (s) =>
    String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Header: altura do topo (sticky) ---------- */
  function measureHeader() {
    const section = $('.section-vm-header');
    if (!section) return;
    const tops = $$('[data-vm-top]', section);
    const h = tops.reduce((acc, el) => acc + el.offsetHeight, 0);
    section.style.setProperty('--vm-top-h', h + 'px');
    const header = $('#vm-header');
    if (header) document.body.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  /* ---------- Mega menu ---------- */
  function initMega() {
    $$('[data-vm-mega]').forEach((wrap) => {
      if (wrap.__vm) return; wrap.__vm = true;
      const btn = $('[data-vm-mega-toggle]', wrap);
      let t;
      const open = () => { clearTimeout(t); wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      const close = () => { t = setTimeout(() => { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 120); };
      btn.addEventListener('click', (e) => { e.preventDefault(); wrap.classList.contains('is-open') ? (wrap.classList.remove('is-open'), btn.setAttribute('aria-expanded', 'false')) : open(); });
      if (window.matchMedia('(hover: hover)').matches) {
        wrap.addEventListener('mouseenter', open);
        wrap.addEventListener('mouseleave', close);
      }
      document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } });
    });
  }

  /* ---------- Drawer (celular) ---------- */
  function initDrawer() {
    const drawer = $('[data-vm-drawer]');
    if (!drawer || drawer.__vm) return; drawer.__vm = true;
    const openD = () => { drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; };
    const closeD = () => { drawer.hidden = true; document.documentElement.style.overflow = ''; };
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-vm-drawer-open]')) openD();
      if (e.target.closest('[data-vm-drawer-close]')) closeD();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) closeD(); });
  }

  /* ---------- Busca instantânea ---------- */
  function initSearch() {
    $$('[data-vm-search]').forEach((form) => {
      if (form.__vm) return; form.__vm = true;
      const input = $('[data-vm-search-input]', form);
      const box = $('[data-vm-search-results]', form);
      let timer, ctrl, active = -1;

      // Texto da busca mais curto no celular
      if (input.dataset.placeholderMobile) {
        const full = input.getAttribute('placeholder') || '';
        const short = input.dataset.placeholderMobile;
        const mq = window.matchMedia('(max-width: 749px)');
        const setPh = () => input.setAttribute('placeholder', mq.matches ? short : full);
        setPh();
        if (mq.addEventListener) mq.addEventListener('change', setPh);
      }
      const hdr = document.querySelector('[data-vm-header]');
      const quoteMode = !!(hdr && hdr.dataset.quoteMode === 'true');
      const hide = () => { box.hidden = true; active = -1; };
      const render = (q, products) => {
        if (!products.length) {
          box.innerHTML = `<div class="vm-search__empty">Nenhuma peça encontrada para "<b>${esc(q)}</b>". Tente pelo código ou pelo nome do veículo.</div>`;
        } else {
          box.innerHTML = products.map((p) => {
            const sku = p.variants && p.variants[0] && p.variants[0].sku;
            const price = Number(String(p.price).replace(',', '.')) * 100;
            const img = p.featured_image && p.featured_image.url
              ? `<img src="${esc(p.featured_image.url)}&width=104" alt="" loading="lazy">`
              : `<span class="vm-search__thumb"></span>`;
            const priceTxt = price <= 1 ? 'Consulte' : money(price);
            return `<a class="vm-search__item" href="${esc(p.url)}">${img}<span><span class="vm-search__name">${esc(p.title)}</span>${sku ? `<span class="vm-search__sku">Cód. ${esc(sku)}</span>` : ''}</span>${quoteMode ? '' : `<span class="vm-search__price">${priceTxt}</span>`}</a>`;
          }).join('') + `<a class="vm-search__all" href="${root}search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(q)}">Ver todos os resultados para "${esc(q)}"</a>`;
        }
        box.hidden = false;
      };

      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) return hide();
        timer = setTimeout(() => {
          if (ctrl) ctrl.abort();
          ctrl = new AbortController();
          const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag`;
          fetch(url, { signal: ctrl.signal })
            .then((r) => r.json())
            .then((d) => render(q, (d.resources && d.resources.results && d.resources.results.products) || []))
            .catch(() => {});
        }, 220);
      });
      input.addEventListener('keydown', (e) => {
        const items = $$('.vm-search__item', box);
        if (box.hidden || !items.length) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          items.forEach((it, i) => it.classList.toggle('is-active', i === active));
        } else if (e.key === 'Enter' && active >= 0) {
          e.preventDefault(); window.location.href = items[active].href;
        } else if (e.key === 'Escape') hide();
      });
      document.addEventListener('click', (e) => { if (!form.contains(e.target)) hide(); });
    });
  }

  /* ---------- Carrosséis de produtos ---------- */
  function initRails(scope = document) {
    $$('[data-vm-rail]', scope).forEach((rail) => {
      if (rail.__vm) return; rail.__vm = true;
      const track = $('[data-vm-rail-track]', rail);
      const prev = $('[data-vm-rail-prev]', rail);
      const next = $('[data-vm-rail-next]', rail);
      if (!track) return;
      const update = () => {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      const step = () => track.clientWidth * 0.9;
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step() }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlides(scope = document) {
    $$('[data-vm-slides]', scope).forEach((el) => {
      if (el.__vm) return; el.__vm = true;
      const slides = $$('[data-vm-slide]', el);
      const dots = $$('[data-vm-dot]', el);
      if (slides.length < 2) return;
      let i = 0, timer;
      const delay = (parseInt(el.dataset.delay, 10) || 6) * 1000;
      const go = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      };
      const play = () => { if (el.dataset.autoplay === 'true') { clearInterval(timer); timer = setInterval(() => go(i + 1), delay); } };
      $('[data-vm-prev]', el)?.addEventListener('click', () => { go(i - 1); play(); });
      $('[data-vm-next]', el)?.addEventListener('click', () => { go(i + 1); play(); });
      dots.forEach((d, k) => d.addEventListener('click', () => { go(k); play(); }));
      el.addEventListener('mouseenter', () => clearInterval(timer));
      el.addEventListener('mouseleave', play);
      let x0 = null;
      el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
        x0 = null;
      });
      go(0); play();
    });
  }

  /* ---------- Busca por veículo ---------- */
  function initVehicle(scope = document) {
    $$('[data-vm-vehicle]', scope).forEach((form) => {
      if (form.__vm) return; form.__vm = true;
      let data = {};
      try { data = JSON.parse($('[data-vm-vehicle-data]', form).textContent); } catch (e) {}
      const selMarca = $('[data-vm-marca]', form);
      const selModelo = $('[data-vm-modelo]', form);
      const inputPeca = $('[data-vm-peca]', form);
      Object.keys(data).forEach((m) => selMarca.add(new Option(m, m)));
      selMarca.addEventListener('change', () => {
        selModelo.length = 1;
        (data[selMarca.value] || []).forEach((mo) => selModelo.add(new Option(mo, mo)));
        selModelo.disabled = !selMarca.value;
      });
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const q = buildVehicleQuery({ marca: selMarca.value, modelo: selModelo.value, peca: inputPeca ? inputPeca.value : '' });
        if (!q) { selMarca.focus(); return; }
        window.location.href = `${root}search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(q)}`;
      });
    });
  }

  /* ---------- Busca por veículo: abrir/fechar no celular ---------- */
  function initVehicleToggle() {
    if (document.__vmVehToggle) return; document.__vmVehToggle = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vm-vehicle-toggle]');
      if (!btn) return;
      const wrap = btn.closest('.vm-header__center');
      if (!wrap) return;
      const open = !wrap.classList.contains('is-vehicle-open');
      wrap.classList.toggle('is-vehicle-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      measureHeader();
    });
  }

  /* ---------- Comprar (vitrines) ---------- */
  function toast(msg) {
    let t = $('.vm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'vm-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = msg;
    requestAnimationFrame(() => t.classList.add('is-visible'));
    clearTimeout(t.__h); t.__h = setTimeout(() => t.classList.remove('is-visible'), 4500);
  }
  function initAdd() {
    if (document.__vmAdd) return; document.__vmAdd = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vm-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      const label = btn.innerHTML;
      btn.disabled = true; btn.textContent = 'Adicionando...';
      fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.vmAdd), quantity: 1 }] }),
      })
        .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
        .then(({ ok, j }) => {
          if (!ok) throw new Error(j.description || j.message || 'Não foi possível adicionar');
          return fetch(`${root}cart.js`).then((r) => r.json());
        })
        .then((cart) => {
          $$('.cart-bubble').forEach((b) => {
            b.classList.remove('visually-hidden');
            const c = $('.cart-bubble__text-count', b);
            if (c) { c.textContent = cart.item_count < 100 ? cart.item_count : ''; c.classList.remove('hidden'); }
          });
          toast(`Peça adicionada ao carrinho! <a href="${root}cart">Ver carrinho</a>`);
        })
        .catch((err) => toast(esc(err.message)))
        .finally(() => { btn.disabled = false; btn.innerHTML = label; });
    });
  }


  /* ---------- Lista de orçamento (UI) ---------- */
  function safeStorage() { try { const s = window.localStorage; const k = '__vm_t'; s.setItem(k, '1'); s.removeItem(k); return s; } catch (e) { return null; } }
  const quote = createQuoteStore(safeStorage());
  const quoteEl = () => $('[data-vm-quote]');
  const quoteNumber = () => { const el = quoteEl(); return (el && el.dataset.wa) || ''; };

  function parseJSON(txt) { try { return JSON.parse(txt); } catch (e) { return null; } }

  function itemFromScope(el) {
    const scope = el.closest('[data-vm-quote-scope]');
    if (!scope) return null;
    const base = parseJSON(scope.dataset.product) || {};
    const variants = parseJSON(($('script[data-vm-variants]', scope) || {}).textContent || '{}') || {};
    let vid = new URLSearchParams(window.location.search).get('variant');
    if (!vid || !variants[vid]) vid = scope.dataset.defaultVariant;
    const v = variants[vid] || {};
    return { id: String(vid), sku: v.sku || '', title: base.title || '', variant: v.title || '', url: base.url || '', image: base.image || '' };
  }

  function quoteRow(it) {
    const img = it.image
      ? `<img class="vm-quote__thumb" src="${esc(it.image)}" alt="" loading="lazy">`
      : `<span class="vm-quote__thumb"><svg class="vm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 2v20M3.3 7l17.4 10M3.3 17 20.7 7"/></svg></span>`;
    const meta = [it.variant, it.sku ? 'Cód. ' + it.sku : ''].filter(Boolean).join(' · ');
    return `<li class="vm-quote__item" data-vm-q-row data-id="${esc(it.id)}">${img}
      <span class="vm-quote__info"><a class="vm-quote__name" href="${esc(it.url)}">${esc(it.title)}</a>${meta ? `<span class="vm-quote__meta">${esc(meta)}</span>` : ''}</span>
      <span class="vm-quote__qty"><button type="button" data-vm-q-dec aria-label="Diminuir">−</button><input type="number" min="1" max="999" value="${it.qty}" data-vm-q-input aria-label="Quantidade"><button type="button" data-vm-q-inc aria-label="Aumentar">+</button></span>
      <button type="button" class="vm-quote__remove" data-vm-q-remove>Remover</button></li>`;
  }

  function refreshQuote() {
    const n = quote.count();
    $$('[data-vm-quote-count]').forEach((el) => { el.textContent = n > 99 ? '99+' : String(n); el.hidden = n === 0; });
    const el = quoteEl(); if (!el) return;
    const items = quote.items();
    const list = $('[data-vm-quote-list]', el);
    if (list) list.innerHTML = items.map(quoteRow).join('');
    const empty = $('[data-vm-quote-empty]', el); if (empty) empty.hidden = items.length > 0 || el.classList.contains('is-sent');
    el.classList.toggle('is-empty', items.length === 0);
  }

  function openQuote() {
    const el = quoteEl(); if (!el) return;
    el.classList.remove('is-sent'); const sent = $('[data-vm-quote-sent]', el); if (sent) sent.hidden = true;
    refreshQuote(); el.hidden = false; document.documentElement.style.overflow = 'hidden';
  }
  function closeQuote() { const el = quoteEl(); if (!el) return; el.hidden = true; document.documentElement.style.overflow = ''; }

  function initQuote() {
    refreshQuote();
    if (document.__vmQuote) return; document.__vmQuote = true;
    document.addEventListener('click', (e) => {
      const add = e.target.closest('[data-vm-quote-add]');
      if (add) {
        e.preventDefault();
        const item = add.dataset.vmQuoteAdd ? parseJSON(add.dataset.vmQuoteAdd) : itemFromScope(add);
        if (!item || !item.id) return;
        const scope = add.closest('[data-vm-quote-scope]');
        const qtyEl = scope && $('[data-vm-quote-qty]', scope);
        quote.add(item, qtyEl ? qtyEl.value : 1);
        refreshQuote();
        toast(`Peça adicionada ao orçamento! <button type="button" data-vm-quote-open>Ver lista</button>`);
        return;
      }
      const direct = e.target.closest('[data-vm-quote-direct]');
      if (direct && direct.closest('[data-vm-quote-scope]')) {
        const item = itemFromScope(direct);
        if (item) { e.preventDefault(); window.open(waLink(quoteNumber() || direct.href.replace(/\D/g, ''), buildDirectMessage(item)), '_blank'); }
        return;
      }
      const step = e.target.closest('[data-vm-qty-step]');
      if (step) {
        const input = $('[data-vm-quote-qty]', step.closest('[data-vm-quote-scope]') || document);
        if (input) input.value = Math.min(999, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.vmQtyStep, 10)));
        return;
      }
      if (e.target.closest('[data-vm-quote-open]')) { e.preventDefault(); setTimeout(openQuote, 0); return; }
      if (e.target.closest('[data-vm-quote-close]')) { closeQuote(); return; }
      const row = e.target.closest('[data-vm-q-row]');
      if (row) {
        const id = row.dataset.id; const cur = (quote.items().find((i) => i.id === id) || {}).qty || 1;
        if (e.target.closest('[data-vm-q-inc]')) { quote.setQty(id, cur + 1); refreshQuote(); }
        else if (e.target.closest('[data-vm-q-dec]')) { quote.setQty(id, Math.max(1, cur - 1)); refreshQuote(); }
        else if (e.target.closest('[data-vm-q-remove]')) { quote.remove(id); refreshQuote(); }
        return;
      }
      if (e.target.closest('[data-vm-quote-clear]')) { quote.clear(); const el = quoteEl(); el.classList.remove('is-sent'); $('[data-vm-quote-sent]', el).hidden = true; refreshQuote(); return; }
      if (e.target.closest('[data-vm-quote-back]')) { openQuote(); }
    });
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-vm-q-input]');
      if (input) { quote.setQty(input.closest('[data-vm-q-row]').dataset.id, input.value); refreshQuote(); }
    });
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-vm-quote-form]');
      if (!form) return;
      e.preventDefault();
      const data = Object.fromEntries(new FormData(form).entries());
      const err = $('[data-vm-quote-error]', form);
      const nomeField = form.elements.nome.closest('.vm-quote__field');
      if (!String(data.nome || '').trim()) { err.hidden = false; nomeField.classList.add('is-invalid'); form.elements.nome.focus(); return; }
      err.hidden = true; nomeField.classList.remove('is-invalid');
      const items = quote.items(); if (!items.length) return;
      window.open(waLink(quoteNumber(), buildQuoteMessage(items, data)), '_blank');
      const el = quoteEl(); el.classList.add('is-sent'); $('[data-vm-quote-sent]', el).hidden = false;
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && quoteEl() && !quoteEl().hidden) closeQuote(); });
    window.addEventListener('storage', (e) => { if (e.key === 'vm_orcamento_v1') refreshQuote(); });
  }

  function init(scope) {
    measureHeader(); initMega(); initDrawer(); initSearch();
    initRails(scope); initSlides(scope); initVehicle(scope); initVehicleToggle(); initAdd(); initQuote();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);

  /* Editor de temas: reinicia ao recarregar seções */
  document.addEventListener('shopify:section:load', (e) => { init(e.target); });
})();
